export default __webpack_public_path__ + "static/Cervejas-blackprincess-72c1af6c008f68f57953c165da62bd31.jpg";